export default class CommonData {
    //组件上下文
    private context: any;

    constructor(context: any) {
        this.context = context
    }

    public get CurrentAccount() {
        let current = this.context.$localStorage.get("account_user_current") || 0;
        return this.context.$localStorage.get("account_user_list")[current];
    }

    public get AccountMsg() {
        let current = this.context.$localStorage.get("account") ;
        return current;
    }


    //获取当前账号下用户ID
    public get USERID() {
        return this.CurrentAccount.userid
    }

    //获取当前账号下用户名
    // public get USERNAME() {
    //     return this.AccountMsg.username
    // }
    public get USERNAME() {
        return this.context.$localStorage.get("Username") 
    }
    //根部菜单节点
    public get KebaiDataWebMenuRoot() {
        let config = this.context.$localStorage.get("system_config").data.filter((item: any) => {
            return item.name == 'kebai-data-web-menu-root'
        })[0]
        return config.value
    }

    //退出登录
    public doLogout() {
        this.context.$localStorage.remove("account");
        window.location.href = "/login.html?web&from=logout";
    }
}